import { useMemo } from 'react';

import { getAdminUrl } from '@utilities';
import { useHasExternals } from '@shared';

const getAdmin: (_organization_id?: string) => AppRouteType = () => ({
  icon: 'link',
  external: true,
  url: getAdminUrl(true),
  menuTitle: 'Voice AI admin',
  className: 'flex flex-row-reverse justify-end gap-sm items-start',
});

export const useExternals: (
  organization_id?: string
) => AppRouteType[] = organization_id => {
  const hasAdmin = useHasExternals();

  return useMemo(
    () => (hasAdmin ? [getAdmin(organization_id)] : []),
    [hasAdmin, organization_id]
  );
};
